import barba from '@barba/core';

barba.hooks.after(() => {
    if (NODE_ENV === 'production') {
        (window as any).ym?.(55716988, 'hit', window.location.pathname);
        (window as any).ga?.('set', 'page', window.location.pathname);
        (window as any).ga?.('send', 'pageview');
    }
});
